import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Company } from 'api/models';
// import { subscribeActiveCompany, getCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import { MeteorObservable } from 'meteor-rxjs';
import { Tabs, Tab, ModalController, NavParams } from 'ionic-angular';
import { App } from "ionic-angular";

import { CompanyInfoTab } from '../company-info-tab/company-info-tab';
import { CompanyUsersTab } from '../company-users-tab/company-users-tab';
import { CompanyProjectsTab } from '../company-projects-tab/company-projects-tab';
import { AddCompanyUserPage } from '../add-company-user/add-company-user';
import { NewProjectComponent } from '../new-project/new-project';
import { APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'company',
  templateUrl: 'company.html'
})
export class CompanyPage implements OnInit {
  @ViewChild('companyTabs') tabRef: Tabs;
  company: Company | void;
  companyInfoTab = CompanyInfoTab;
  companyUsersTab = CompanyUsersTab;
  companyProjectsTab = CompanyProjectsTab;
  selectedTab: Tab;
  selectedTabView: CompanyInfoTab | CompanyUsersTab | CompanyProjectsTab | void;
  title = 'Company';
  companyInfoTabParams: Object;
  companyUsersTabParams: Object;
  companyProjectsTabParams: Object;

  constructor(
    private _app: App,
    private modalCtrl: ModalController,
    public navParams: NavParams,
    public companyService: CompanyService,
    private httpService: HttpService,
    private router: Router,
    private sharedService: SharedService,
  ) {
    const companyId = navParams.get('companyId');
    this.companyInfoTabParams = {
      companyId,
    };
    this.companyUsersTabParams = {
      companyId,
    };
    this.companyProjectsTabParams = {
      companyId,
    };
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit(): void {
  console.log('company page');
    const companyId = this.navParams.get('companyId');
    if (companyId) {
      this.company = this.companyService.getCompany(companyId);
    } else {
      this.company = this.companyService.subscribeActiveCompany();
    }
    this.httpService.privateLoopAction(true).then(res=>{
      MeteorObservable.autorun().subscribe(() => {
        if (companyId) {
          this.company = this.companyService.getCompany(companyId);
        } else {
          this.company = this.companyService.subscribeActiveCompany();
        }
      });
    });
  }

  onTabChange() {
    this.selectedTab = this.tabRef.getSelected();
    this.selectedTabView = this.selectedTab.root;
    this.title = 'Company ' + this.selectedTab.tabTitle;

    if (this.company) { // this.company may not be instantiated by the time this code runs, in a cold start

      if (this.selectedTab.tabTitle == 'Details') {
        this.router.navigate([this.company.name, 'details']);
      }
      if (this.selectedTab.tabTitle == 'Members') {
        this.router.navigate([this.company.name, 'members']);
      }
      if (this.selectedTab.tabTitle == 'Projects') {
        this.router.navigate([this.company.name, 'projects']);
      }
    }
  }

  goToCreateProject(): void {
    if (!this.company) {
      return;
    }
    const modal = this.modalCtrl.create(NewProjectComponent, {companyId: this.company._id}, {enableBackdropDismiss: false});
    modal.present();
    this.router.navigate([this.company.name, 'addNewProject']);

    modal.onDidDismiss(() => {        
      if (this.company) {
        this.router.navigate([this.company.name, 'projects']); 
      }  
    });
  }

  goToCreateCompanyMember(): void {
    const modal = this.modalCtrl.create(AddCompanyUserPage, {company: this.company}, {enableBackdropDismiss: false});
    modal.present();

    if (this.company) { // this.company may not be instantiated by the time this code runs, in a cold start
      this.router.navigate([this.company.name, 'addNewMember']);

      modal.onDidDismiss(() => {    
        if (this.company) {
          this.router.navigate([this.company.name, 'members']); 
        }  
      });
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/company/company.ts